export const CNB_TYPE = {
    NONE: '',
    A: 'A', // A : 게임 사이트
    B: 'B', // B : 게임 프로모션, 업데이트 연대기 사이트 - 서비스 전체보기, BI, 로그인 / 로그아웃
    C: 'C', // C : 회원 사이트 (마이페이지, 고객센터, N샵)
    D: 'D', // D : 기타 사이트 (메인, 약관/정책, 공지사항, 장기 미이용 복귀 센터, 게임시간선택제)
    PURPLE: 'PURPLE' // PURPLE: 퍼플 웹뷰에서 사용하는 CNB
};

export const AREA_TYPE = {
    NCK: 'NCK', // CNB 파일이 NCK static에 존재 / 글로벌 대응 (TL, LW 등등)
    NCT: 'NCT', // CNB 파일이 NCK static에 존재 (NCT에서만 사용)
    NCJ: 'NCJ', // CNB 파일이 NCK static에 존재 (NCJ에서만 사용)
    NCV: 'NCV', // CNB 파일이 NCK static에 존재 (NCV 에서만 사용)
    NCA_EN_US: 'NCA_EN_US', // CNB 파일이 NCK static에 존재 (NCA 에서만 사용)
    NCA_EN_GB: 'NCA_EN_GB', // CNB 파일이 NCK static에 존재 (NCA 에서만 사용)
    NCA_DE: 'NCA_DE', // CNB 파일이 NCK static에 존재 (NCA 에서만 사용)
    NCA_FR: 'NCA_FR', // CNB 파일이 NCK static에 존재 (NCA 에서만 사용)
};

// 원래 'NC' 라는 country_code 는 
// 회사에서 관리하고 있지 않은 국가에서 접속 하는 경우 
// 내려주는 default country code 였으나, 
// 제거 되고, '뉴칼레도니아' 의 국가 코드로 대체 되었음 
export const COUNTRY_CODE = {
    KR: 'KR', // 대한민국 
    JP: 'JP', // 일본
    ID: 'ID', // 인도네시아	
    TH: 'TH', // 태국
    BR: 'BR', // 브라질
    IT: 'IT', // 이탈리아
    ES: 'ES', // 스페인
    TR: 'TR', // 터키
    FR: 'FR', // 프랑스
    TW: 'TW', // 대만
    HK: 'HK', // 홍콩
    MO: 'MO', // 마카오
    SA: 'SA', // 사우디아라비아	
    AE: 'AE', // 아랍에미리트	
    QA: 'QA', // 카타르
    DE: 'DE', // 독일
    CH: 'CH', // 스위스
    AT: 'AT', // 오스트리아	
    RO: 'RO', // 루마니아
    MX: 'MX', // 멕시코
    CL: 'CL', // 칠레
    AR: 'AR', // 아르헨티나
    PE: 'PE', // 페루
    CO: 'CO', // 콜롬비아
    EC: 'EC', // 에콰도르
    RU: 'RU', // 러시아
    UA: 'UA', // 우크라이나
    BY: 'BY', // 벨라루스
    LT: 'LT', // 리투아니아
    PL: 'PL', // 폴란드
    GR: 'GR', // 그리스
    KW: 'KW', // 쿠웨이트
    KZ: 'KZ', // 카자흐스탄
    UZ: 'UZ', // 우즈베키스탄
    AZ: 'AZ', // 아제르바이잔
    GE: 'GE', // 조지아
    MD: 'MD', // 몰도바
    AM: 'AM', // 아르메니아
    US: 'US', // 미국
    MY: 'MY', // 말레이시아
    SG: 'SG', // 싱가포르
    PH: 'PH', // 필리핀
    CA: 'CA', // 캐나다
    GB: 'GB', // 영국
    NO: 'NO', // 노르웨이
    SE: 'SE', // 스웨덴
    IE: 'IE', // 아일랜드
    PT: 'PT', // 포르투갈
    FI: 'FI', // 핀란드
    DK: 'DK', // 덴마크
    NL: 'NL', // 네덜란드
    IN: 'IN', // 인도
    PK: 'PK', // 파키스탄
    EG: 'EG', // 이집트
    ZA: 'ZA', // 남아프리카공화국
    AU: 'AU', // 호주
    IL: 'IL', // 이스라엘
    BE: 'BE', // 벨기에
    LU: 'LU', // 룩셈부르크
    HU: 'HU', // 헝가리
    CZ: 'CZ', // 체코
    LV: 'LV', // 라트비아
    SI: 'SI', // 슬로베니아
    SK: 'SK', // 슬로바키아
    BG: 'BG', // 불가리아
    RS: 'RS', // 세르비아
    BA: 'BA', // 보스니아 헤르체고비나
    HR: 'HR', // 크로아티아
    MK: 'MK', // 북마케도니아
    DZ: 'DZ', // 알제리
    TN: 'TN', // 튀니지
    MA: 'MA', // 모로코
    GH: 'GH', // 가나
    NG: 'NG', // 나이지리아
    TZ: 'TZ', // 탄자니아
    KE: 'KE', // 케냐
    IQ: 'IQ', // 이라크
    JO: 'JO', // 요르단
    LB: 'LB', // 레바논
    YE: 'YE', // 예멘
    BH: 'BH', // 바레인
    OM: 'OM', // 오만
    NP: 'NP', // 네팔
    KH: 'KH', // 캄보디아
    LK: 'LK', // 스리랑카
    KG: 'KG', // 키르기스스탄
    NZ: 'NZ', // 뉴질랜드
    PY: 'PY', // 파라과이
    HN: 'HN', // 온두라스
    GT: 'GT', // 과테말라
    CR: 'CR', // 코스타리카
    SV: 'SV', // 엘살바도르
    PA: 'PA', // 파나마
    VE: 'VE', // 베네수엘라
    UY: 'UY', // 우루과이
    BO: 'BO', // 볼리비아
    JM: 'JM', // 자메이카
    TT: 'TT', // 트리니다드 토바고
    DO: 'DO', // 도미니카 공화국
    MT: 'MT', // 몰타
    CY: 'CY', // 키프로스
    EE: 'EE', // 에스토니아
    GA: 'GA', // 가봉
    GM: 'GM', // 감비아
    GD: 'GD', // 그레나다
    GN: 'GN', // 기니
    GW: 'GW', // 기니비사우
    NA: 'NA', // 나미비아
    NE: 'NE', // 니제르
    NI: 'NI', // 니카라과
    DM: 'DM', // 도미니카
    LA: 'LA', // 라오스
    LR: 'LR', // 라이베리아
    RW: 'RW', // 르완다
    LY: 'LY', // 리비아
    LI: 'LI', // 리히텐슈타인
    ML: 'ML', // 말리
    MC: 'MC', // 모나코
    MU: 'MU', // 모리셔스
    MZ: 'MZ', // 모잠비크
    MV: 'MV', // 몰디브
    MM: 'MM', // 미얀마
    FM: 'FM', // 미크로네시아
    VU: 'VU', // 바누아투
    VA: 'VA', // 바티칸 시국
    BS: 'BS', // 바하마
    BD: 'BD', // 방글라데시
    BM: 'BM', // 버뮤다
    BJ: 'BJ', // 베냉
    BZ: 'BZ', // 벨리즈
    BW: 'BW', // 보츠와나
    BF: 'BF', // 부르키나파소
    WS: 'WS', // 사모아
    SM: 'SM', // 산마리노
    SN: 'SN', // 세네갈
    SC: 'SC', // 세이셸
    LC: 'LC', // 세인트루시아
    KN: 'KN', // 세인트키츠 네비스
    SO: 'SO', // 소말리아
    SB: 'SB', // 솔로몬 제도
    SD: 'SD', // 수단
    SR: 'SR', // 수리남
    SL: 'SL', // 시에라리온
    AW: 'AW', // 아루바
    IS: 'IS', // 아이슬란드
    HT: 'HT', // 아이티
    AL: 'AL', // 알바니아
    AO: 'AO', // 앙골라
    AG: 'AG', // 앤티가 바부다
    ER: 'ER', // 에리트리아
    VG: 'VG', // 영국령 버진아일랜드
    UG: 'UG', // 우간다
    IR: 'IR', // 이란
    ZM: 'ZM', // 잠비아
    DJ: 'DJ', // 지부티
    GI: 'GI', // 지브롤터
    ZW: 'ZW', // 짐바브웨
    TD: 'TD', // 차드
    CM: 'CM', // 카메룬
    CV: 'CV', // 카보베르데
    KY: 'KY', // 케이맨 제도
    KM: 'KM', // 코모로
    CI: 'CI', // 코트디부아르
    CG: 'CG', // 콩고-브라자빌
    CD: 'CD', // 콩고-킨샤사
    CU: 'CU', // 쿠바
    CW: 'CW', // 퀴라소
    TJ: 'TJ', // 타지키스탄
    TC: 'TC', // 터크스 케이커스 제도
    TG: 'TG', // 토고
    TO: 'TO', // 통가
    TM: 'TM', // 투르크메니스탄
    PG: 'PG', // 파푸아뉴기니
    FJ: 'FJ', // 피지
    GY: 'GY', // 가이아나
    GG: 'GG', // 건지
    GP: 'GP', // 과들루프
    GU: 'GU', // 괌
    GL: 'GL', // 그린란드
    NR: 'NR', // 나우루
    AQ: 'AQ', // 남극 대륙
    NF: 'NF', // 노퍽섬
    NC: 'NC', // 뉴칼레도니아
    NU: 'NU', // 니우에
    TL: 'TL', // 동티모르
    LS: 'LS', // 레소토
    RE: 'RE', // 레위니옹
    MG: 'MG', // 마다가스카르
    MQ: 'MQ', // 마르티니크
    MH: 'MH', // 마셜 제도
    YT: 'YT', // 마요트
    MW: 'MW', // 말라위
    IM: 'IM', // 맨섬
    MR: 'MR', // 모리타니
    ME: 'ME', // 몬테네그로
    MS: 'MS', // 몬트세랫
    MN: 'MN', // 몽골
    UM: 'UM', // 미국령 군소 제도
    VI: 'VI', // 미국령 버진아일랜드
    BB: 'BB', // 바베이도스
    BI: 'BI', // 부룬디
    BV: 'BV', // 부베섬
    BT: 'BT', // 부탄
    MP: 'MP', // 북마리아나제도
    BN: 'BN', // 브루나이
    BQ: 'BQ', // 사바
    GS: 'GS', // 사우스 조지아 및 사우스 샌드위치 제도
    ST: 'ST', // 상투메 프린시페
    MF: 'MF', // 생마르탱
    BL: 'BL', // 생바르텔레미
    PM: 'PM', // 생피에르 미클롱
    EH: 'EH', // 서사하라
    VC: 'VC', // 세인트 빈센트 그레나딘
    SH: 'SH', // 세인트헬레나 어센션 트리스탄다쿠냐
    SJ: 'SJ', // 스발바르제도-얀마웬섬
    AS: 'AS', // 아메리칸 사모아
    AF: 'AF', // 아프가니스탄
    AD: 'AD', // 안도라
    AI: 'AI', // 앵귈라
    SZ: 'SZ', // 에스와티니
    ET: 'ET', // 에티오피아
    IO: 'IO', // 영국령 인도양 지역
    AX: 'AX', // 올란드 제도
    WF: 'WF', // 왈리스-푸투나 제도
    JE: 'JE', // 저지
    GQ: 'GQ', // 적도 기니
    CF: 'CF', // 중앙 아프리카 공화국
    XK: 'XK', // 코소보
    CC: 'CC', // 코코스 제도
    CK: 'CK', // 쿡 제도
    CX: 'CX', // 크리스마스섬
    KI: 'KI', // 키리바시
    TK: 'TK', // 토켈라우
    TV: 'TV', // 투발루
    PW: 'PW', // 팔라우
    PS: 'PS', // 팔레스타인 자치정부
    FO: 'FO', // 페로 제도
    FK: 'FK', // 포클랜드 제도(말비나스 군도)
    PR: 'PR', // 푸에르토리코
    GF: 'GF', // 프랑스령 기아나
    TF: 'TF', // 프랑스령 남방 지역
    PF: 'PF', // 프랑스령 폴리네시아
    PN: 'PN', // 피트카이른
    HM: 'HM', // 허드 맥도널드 제도
};

// 언어 코드
export const LANG_CODE = {
    KO: 'ko',
    EN: 'en',
    ZH: 'zh',
    JA: 'ja',
    DE: 'de',
    FR: 'fr',
    ES: 'es',
    TH: 'th',
    VI: 'vi',
    ID: 'id',
    RU: 'ru',
    AR: 'ar',
    PL: 'pl',
    IT: 'it',
    PT: 'pt'
};

export const NETWORK = {
    opdev: 'opdev',
    sb: 'sb',
    rc: 'rc',
    stage: 'stage',
    live: 'live'
};

export const LNB_LINK_TYPE = {
    NEW: 'new',
    EXTERNAL: 'external',
    POPUP: 'popup'
}

// cnb 언어파일 호출 - locale 반환
export const getLangFileLocaleName = () => {
    const lang = document.documentElement.lang || LANG_CODE.KO;

    switch(lang) {
        case LANG_CODE.ZH:
            return 'zh_Hant';
        case LANG_CODE.ES:
            const userLocale = window?.userData?.locale;
            const dataCountry = document.querySelector('html')?.dataset?.country;
            const isEs = userLocale ? (/-es$/i).test(userLocale) : dataCountry ? (/^es$/i).test(dataCountry) : false;
            return isEs ? 'es_ES' : 'es_MX';
        default:
            return lang;
    }
};

// noti - 알림리스트 언어코드 반환
const NOTI_LANG_CODE = {
    [LANG_CODE.KO]: 'ko-KR',
    [LANG_CODE.EN]: 'en-US',
    [LANG_CODE.ZH]: ['zh-TW', 'zh-CN'], // zh-TW: 중국어(대만), zh-CN: 중국어(번체)
    [LANG_CODE.JA]: 'ja-JP',
    [LANG_CODE.DE]: 'de-DE',
    [LANG_CODE.FR]: 'fr-FR',
    [LANG_CODE.ES]: ['es-ES'],
    [LANG_CODE.TH]: 'th-TH',
    [LANG_CODE.VI]: 'vi-VN',
    [LANG_CODE.ID]: 'id-ID',
    [LANG_CODE.RU]: 'ru-RU',
    [LANG_CODE.AR]: 'ar-AE',
    [LANG_CODE.PL]: 'PL'
};
export const getNotiLangCode = () => {
    const lang = document.documentElement.lang || LANG_CODE.KO;
    const userLocale = window?.userData?.locale;
    const dataCountry = document.querySelector('html')?.dataset?.country;

    switch(lang) {
        case LANG_CODE.ZH:
            const isCN = userLocale ? (/-cn$/i).test(userLocale) : dataCountry ? (/^cn$/i).test(dataCountry) : false;
            return isCN ? NOTI_LANG_CODE[LANG_CODE.ZH][1] : NOTI_LANG_CODE[LANG_CODE.ZH][0];
        case LANG_CODE.ES:
            // const isEs = userLocale ? (/-es$/i).test(userLocale) : dataCountry ? (/^es$/i).test(dataCountry) : false;
            // return isEs ? NOTI_LANG_CODE[LANG_CODE.ES][0] : NOTI_LANG_CODE[LANG_CODE.ES][1]; // 추후 es-MX 생길 때 대비
            return NOTI_LANG_CODE[LANG_CODE.ES][0];
        default:
            return NOTI_LANG_CODE[lang];
    }
};